import React from 'react';

import { ExternalLink } from 'components/Links';

import { formatDate } from 'utils/formatting';

export function IncludeExcludeDescription({ exclude, excludedUntil }: { exclude: boolean; excludedUntil?: string }) {
  return (
    <>
      Status will be set as{' '}
      {exclude
        ? `Excluded, and will not be set as Needs Review ${
            excludedUntil ? `until ${formatDate(excludedUntil)}` : `in the future`
          }.`
        : 'Needs Review or OK in the future.'}
      <br />
      <br />
      Excluding items lets you exclude items from planning permanently or temporarily by setting a custom or predefined
      return date. This helps you manage timing and reduce noise in your workflow. Excluded items automatically reappear
      in planning once the snooze period ends. Items excluded through Rules must be re-included through the specific
      Rule. Learn more{' '}
      <ExternalLink to="https://help.recurrency.com/hc/en-us/articles/30951168098843-Using-Recommendation-Snoozing">
        here
      </ExternalLink>
      .
    </>
  );
}
